import React, { useState, useRef } from 'react'
import Tools from '../../../components/Tools/Tools'
import ProceedForApproval from '../../../components/ProceedForApproval/ProceedForApproval'
import ProceedForApprovalHeader from '../../../components/ProceedForApproval/ProceedForApprovalHeader'
import { useLocation, useNavigate } from 'react-router-dom'
import { Accordion } from 'react-bootstrap'
import SubHeader from '../../../components/Subheader/Subheader'
import { useSelector } from "react-redux";
import CustomBreadcrumbs from '../../../components/Tools/Breadcumbs'


const Approval = () => {
  const navigate = useNavigate();
  let { state } = useLocation();
  const [data,setData]=useState(state && state.data ? state.data:[]);

  const linksArray = [
    {
      href: "/fund-invoice-list?pending=false",
      label: "Invoice Approval",
    }
  ]

  return (
    <div>
        <div className='scheme p-2'>
          <div className="row" style={{ padding: "10px 16px" }}>
            <div className="col-md-6">
              <h4 style={{ color: "#28326f", margin: 0 }}>Approval Process</h4>
              <CustomBreadcrumbs linksArray={linksArray} title="Approval Process" />
            </div>
            <div className="col-md-6">
            </div>
          </div>
        <Accordion defaultActiveKey="approval_invoice_0" flush>
          {
            data.length>0 && data.map((invoice,i)=>{
              return (                
                <Accordion.Item eventKey={"approval_invoice_"+i}>
                  <Accordion.Header>INVOICE- {i+1}</Accordion.Header>
                    <Accordion.Body style={{border:"1px solid #2490ea", borderRadius: "7px"}}>
                      <ProceedForApproval invoice={invoice} setInvoices={setData} index={i} />  
                    </Accordion.Body>
                </Accordion.Item>
              );
            })
          }
          </Accordion>
          
        </div>
    </div>
  )
}

export default Approval
